function applyIntersectionObserver(className, callback, disconnect = false) {
  const threshold = 0.1;
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        callback(entry, observer);
        if (disconnect && entry.isIntersecting) {
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold }
  );

  const elements = document.querySelectorAll(className);
  elements.forEach((element) => observer.observe(element));
}

window.applyIntersectionObserver = applyIntersectionObserver;
